import React, { useContext } from "react";
import styled from "styled-components";

import { ShowLandingContext } from "./ShowLandingContextWrapper";

import LandingButton from "./LandingButton";
import ShadowButton from "./ShadowButton";
import SpriteImage from "../common/styles/SpriteImage";

const LandingWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: auto;
    margin-left: auto;
    margin-top: -30px;
    text-align: center;
`;

LandingWrapper.displayName = "LandingWrapper";

function Landing() {
    const { setShowLanding } = useContext(ShowLandingContext);

    return (
        <LandingWrapper>
            <LandingButton onClick={() => setShowLanding(false)}>
                <SpriteImage className="bg-click-to-start" alt="Click to Start" />
            </LandingButton>
            <ShadowButton>
                <SpriteImage className="bg-click-to-start-shadow" />
            </ShadowButton>
        </LandingWrapper>
    );
}

export default Landing;
